<style lang="scss" scoped>

h3.page-title,
.account-question-paragraph {
    color: #000 !important;
}

.content {
    left: 0;
    width: 100% !important;
}

h3.page-title {
    font-size: 24px;
    line-height: 29px;
    margin-bottom: 35px;
}

.form-row .form-group:first-child {
    padding-left: 0;
    padding-right: 8px;
}

.registration-problems {
    margin-bottom: 130px;
    font-weight: bold;
    font-size: 12px;
    line-height: 13px;
}

.register-button {
    margin: 26px 0 36px 0 !important;
    padding-left: 35px;
    padding-right: 35px;
}

.account-question-paragraph {
    margin-bottom: 58px;
    font-weight: bold;
    font-size: 15px;
    line-height: 13px;
}

.image-section {
    background-image: url("../assets/images/register-img.jpg");
    font-family: "Open Sans", sans-serif;
    position: relative;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}

.password__feedback {
    align-items: center;
    display: inline-block;
    font-size: 10px;

    > i {
        margin-right: 2px;
    }

    &--invalid, &--valid {
        margin-top: 2px;
        margin-right: 10px;
    }

    &--invalid {
        color: red;
    }

    &--valid {
        color: green;
    }
}

.text-section {
    color: #ffffff;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin: 0 160px;
}

.invalid-feedback {
    color: red;
    margin-left: 12px;
    margin-bottom: 0;
}

.form-check {
    margin-bottom: 7px;
}

.form-check-label {
    margin: 0 0 0 20px;
    font-size: 12px;
    font-weight: 300;
    line-height: 13px;
    transform: translateY(-2px);
}

.overlay {
    opacity: 0.8;
    color: #fff;
    background: #003B71;
    width: 100%;
    height: 100%;
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
}


.form-row {
    margin-left: 0;
    margin-right: 0;
}

.custom-checkbox__checkmark {
    margin-top: 0 !important;
}

.m-b-5 {
    margin-bottom: 5px;
}

.myAmpleon .main .container {
    width: auto;
}

.image-title-second {
    margin-bottom: 40px;
}

.form-section {
    padding: 0 75px;
}

.form-row .form-group:nth-child(2) {
    padding-right: 0;
    padding-left: 8px;
}

.form-group-country {
    padding: 0 !important;
}

.top-bar {
    background-color: #003b71;
    height: 60px;
    width: 100%;
    top: 50px;
    left: 0;
    z-index: 2;
    overflow: hidden;
}

.form-group {
    margin-bottom: 22px;
}

.form-group-check-first {
    margin-bottom: auto;
}

.registration-wrapper-row {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
}

.form-section {
    display: flex;
    flex-direction: column;
    height: auto;

}

.parametric-intro {
    margin: 0;
    padding-top: 43px !important;
}

.custom-checkbox-wrapper {
    margin: 0;
}

.image-paragraph {
    margin: 0;
    font-size: 14px;
    line-height: 22px;
    font-weight: 300;
}

.image-title {
    font-size: 24px;
    line-height: 38px;
    margin: 0 0 48px 0;
}

input[type=checkbox],
input[type=radio] {
    margin: 0;
    transform: translateY(-12px);
}

/*Responsive design*/

@media (max-width: 768px) {
    .overlay .text-section {
        margin: 0 15px;
    }
    .text-section {
        top: 38%;
    }
    .registration-wrapper-row .image-section {
        height: 402px;
    }
}


@media (max-width: 992px) {

    .form-row .form-group:nth-child(2) {
        padding-right: 0;
        padding-left: 0;
    }

    .form-row .form-group:first-child {
        padding-left: 0;
        padding-right: 0;
    }

    .form-section {
        padding: 0 15px;
        width: 100%;
    }

    .page-title {
        padding-left: 0 !important;
    }
    .registration-problems {
        margin-bottom: 20px;
    }
    .image-section {
        order: 1;
        height: 464px;
        width: 100%;
    }
    .form-section {
        order: 2;
    }

    .text-section {
        margin: 0 20%;
    }
}

.form-group-check-second {
    margin-bottom: 0;
}

.form-control {
    padding: 5px 18px;
    border-color: #ddd;

    &::-webkit-input-placeholder { /* Edge */
        color: #000;
        font-size: 14px;
        font-weight: lighter;
    }

    &:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #000;
        font-size: 14px;
        font-weight: lighter;
    }

    &::placeholder {
        color: #000;
        font-size: 14px;
        font-weight: lighter;
    }
}
</style>

<template>
    <div class="registration-wrapper">
        <div class="top-bar">
        </div>
        <div class="row registration-wrapper-row">
            <div class="col-md-6 col-sm-12 form-section">
                <div class="parametric-intro">
                    <h3 class="page-title">Register now</h3>
                </div>

                <div class="account-question">
                    <p class="account-question-paragraph">Already have an account?
                        <router-link :to="{path: '/'}"><b>Login</b></router-link>
                    </p>

                    <form @submit.prevent="handleSubmit" autocomplete="off" novalidate>
                        <div class="row form-row">
                            <div class="form-group col-md-6">
                                <input type="text" v-model="user.firstName" class="form-control" id="firstName"
                                       placeholder="First Name *"
                                       :class="{ 'is-invalid': formErrors && $v.user.firstName.$error }">
                                <p v-if="formErrors && !$v.user.firstName.required" class="invalid-feedback">First name
                                    is required.</p>
                            </div>
                            <div class="form-group col-md-6">
                                <input type="text" v-model="user.lastName" class="form-control" id="lastName"
                                       placeholder="Last Name *"
                                       :class="{ 'is-invalid': formErrors && $v.user.lastName.$error }">
                                <p v-if="formErrors && !$v.user.lastName.required" class="invalid-feedback">Last name is
                                    required.</p>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="form-group col-md-6">
                                <input type="text" v-model="user.email" class="form-control" id="inputEmail"
                                       placeholder="Email *"
                                       :class="{ 'is-invalid': formErrors && $v.user.email.$error }">
                                <div v-if="formErrors && $v.user.email" class="invalid-feedback">
                                    <p v-if="formErrors && !$v.user.email.required">E-mail address is required.</p>
                                    <p v-else-if="!$v.user.email.email">Please enter a valid e-mail address.</p>
                                </div>
                                <div v-if="emailExists" class="invalid-feedback">
                                    <p>The provided email already exist.</p>
                                </div>
                            </div>

                            <div class="form-group col-md-6">
                                <input type="text" v-model="user.confirmEmail" class="form-control" id="confirmEmail"
                                       placeholder="Confirm E-mail *"
                                       :class="{ 'is-invalid': formErrors && $v.user.confirmEmail.$error }">
                                <div v-if="formErrors && $v.user.confirmEmail.$error" class="invalid-feedback">
                                    <p v-if="formErrors && !$v.user.confirmEmail.required">Please re-type your e-mail
                                        address.</p>
                                    <p v-else-if="!$v.user.confirmEmail.sameAsEmail">E-mail addresses don't match.
                                        Please try again.</p>
                                </div>
                            </div>
                        </div>


                        <div class="row form-row">
                            <div class="form-group col-md-6">
                                <PasswordFieldWithStrengthMeter
                                        v-model="user.password"
                                        :email="user.email"
                                        :include-password-history="false"
                                        :submitted="submitted"
                                >
                                </PasswordFieldWithStrengthMeter>
                            </div>

                            <div class="form-group col-md-6">
                                <input type="password" v-model="user.confirmPassword" class="form-control"
                                       id="confirmPassword" placeholder="Confirm Password *"
                                       :class="{ 'is-invalid': formErrors && $v.user.confirmPassword.$error }">
                                <div v-if="formErrors && $v.user.confirmPassword.$error" class="invalid-feedback">
                                    <p v-if="formErrors && !$v.user.confirmPassword.required">Please confirm
                                        password.</p>
                                    <p v-else-if="!$v.user.confirmPassword.sameAsPassword">Passwords don't match. Please
                                        try again.</p>
                                </div>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="form-group col-md-6">
                                <input type="text" v-model="user.company" class="form-control" id="company"
                                       placeholder="Full Company Name *"
                                       :class="{ 'is-invalid': formErrors && $v.user.company.$error }">
                                <p v-if="formErrors && !$v.user.company.required" class="invalid-feedback">Company name
                                    is required.</p>
                            </div>

                            <div class="form-group col-md-6">
                                <input type="text" v-model="user.phone" class="form-control" id="phone"
                                       placeholder="Phone">
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="form-group col-md-6">
                                <select id="job-description" v-model="user.job" class="form-control"
                                        :class="{ 'is-invalid': formErrors && $v.user.job.$error }">
                                    <option value="" disabled hidden>Job Description *</option>
                                    <option value="Academic-Professor">Academic-Professor</option>
                                    <option value="Academic-Student">Academic-Student</option>
                                    <option value="Distribution">Distribution</option>
                                    <option value="Engineer-Applications">Engineer - Applications</option>
                                    <option value="Engineer-Component/Product">Engineer - Component/Product</option>
                                    <option value="Engineer-Design">Engineer - Design</option>
                                    <option value="Engineer-Firmware">Engineer - Firmware</option>
                                    <option value="Engineer-Hardware">Engineer - Hardware</option>
                                    <option value="Engineer-Software">Engineer - Software</option>
                                    <option value="Engineer-System">Engineer - System</option>
                                    <option value="Engineer-System Architect">Engineer - System Architect</option>
                                    <option value="Engineer-Manufacturing/Process">Engineer-Manufacturing/Process
                                    </option>
                                    <option value="Field Application Engineer">Field Application Engineer</option>
                                    <option value="Marketing">Marketing</option>
                                    <option value="Program/Project Manager">Program/Project Manager</option>
                                    <option value="Purchasing/Supply Management">Purchasing/Supply Management</option>
                                    <option value="Quality">Quality</option>
                                    <option value="Sales">Sales</option>
                                    <option value="Other">Other</option>
                                </select>
                                <p v-if="formErrors && !$v.user.job.required" class="invalid-feedback">Please select
                                    your job description.</p>
                            </div>

                            <div class="form-group col-md-6">
                                <input type="text" v-model="user.business" class="form-control" id="business"
                                       placeholder="Business Title *"
                                       :class="{ 'is-invalid': formErrors && $v.user.business.$error }">
                                <p v-if="formErrors && !$v.user.business.required" class="invalid-feedback">Business
                                    title is required.</p>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="form-group col-md-12 form-group-country">
                                <select id="country" v-model="user.country" class="form-control"
                                        :class="{ 'is-invalid': formErrors && $v.user.country.$error }">
                                    <option value="" disabled hidden>Country *</option>
                                    <option v-model="user.country" v-for="country in countries" :value="country.code">
                                        {{country.name}}
                                    </option>
                                </select>
                                <p v-if="formErrors && !$v.user.country.required" class="invalid-feedback">Please select
                                    country.</p>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="form-group form-group-check-first  col-md-12 m-b-5">
                                <div class="form-check">
                                    <span class="custom-checkbox custom-checkbox-wrapper">
                                        <input class="custom-checkbox__input" type="checkbox"
                                               v-model="user.subscribed"
                                               id="checkboxNews"
                                        />
                                        <span class="custom-checkbox__checkmark">
                                        </span>
                                    </span>
                                    <label class="form-check-label custom-control-label" for="checkboxNews">I want to
                                        receive the latest information on product news, events and documentation</label>
                                </div>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="form-group form-group-check-second col-md-12">
                                <div class="form-check">
                                    <span class="custom-checkbox custom-checkbox-wrapper">
                                        <input class="custom-checkbox__input" v-model="user.terms" type="checkbox"
                                               id="checkboxTerms"
                                               :class="{ 'is-invalid': formErrors && $v.user.terms.$error }"
                                               oninvalid="function f() {}"
                                        />
                                        <span class="custom-checkbox__checkmark">
                                        </span>
                                    </span>
                                    <label class="form-check-label custom-control-label" for="checkboxTerms">I have read
                                        and accept the <a href="https://www.ampleon.com/about/terms-of-use.html"><b>Terms
                                            of Use</b></a> and <a href="https://www.ampleon.com/about/privacy.html"><b>Privacy
                                            Policy</b></a> *</label>
                                </div>
                                <div v-if="formErrors && $v.user.terms.$error"
                                     class="invalid-feedback form-group form-group-check-second col-md-12">
                                    <p>Please acknowledge that you have read and understand our Terms of Use and Privacy
                                        Policy.</p>
                                </div>
                            </div>
                        </div>

                        <ReCaptchaTerms></ReCaptchaTerms>

                        <div class="row form-row">
                            <div class="form-group col-md-12">
                                <button type="submit" :disabled="!countryFetchSucceeded || isPending"
                                        class="btn btn-primary register-button">Register
                                </button>
                            </div>
                        </div>
                    </form>

                    <div class="row form-row registration-problems">
                        <div class="form-group col-md-12">
                            <router-link :to="{path: '/registration-and-login-support'}">Problems with registration?
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-sm-12 image-section">
                <div class="overlay">
                    <div class="text-section">
                        <h2 class="image-title">Register now and enjoy the benefits of myAmpleon</h2>
                        <p class="image-paragraph">MyAmpleon offers you valuable content, integrated services and a
                            personalized experience at your fingertip.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {required, email, minLength, sameAs} from "vuelidate/lib/validators";
import {UserService} from "@/common/api.service";
import {REGISTER_USER, FINALIZE_ACTION} from "@/store/actions.type";
import {STATUS, mapAsyncGetters} from "@/store/utils/async";
import ReCaptchaTerms from "../components/ReCaptchaTerms";
import PasswordFieldWithStrengthMeter from "@/components/PasswordFieldWithStrengthMeter";

const customPassword = value => {
    return /^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[\d]){1,})(?=.*[^\w\s]{1,})(.{8,40})$/.test(value)
};

export default {
    name: "Registration",
    components: {
        ReCaptchaTerms,
        PasswordFieldWithStrengthMeter
    },
    data() {
        return {
            user: {
                firstName: "",
                lastName: "",
                email: "",
                confirmEmail: "",
                password: "",
                confirmPassword: "",
                company: "",
                phone: "",
                job: "",
                business: "",
                country: "",
                subscribed: false,
                terms: "",
                token: ""
            },
            submitted: false,
            formErrors: false,
            regexes: {
                atLeastOneDigitRegex: /\d/,
                atLeastOneUpperCaseRegex: /[A-Z]/,
                atLeastOneLowerCaseRegex: /[a-z]/,
                atLeastOneSpecialCharRegex: /[^\w\s]/,
                atLeastEightCharRegex: /.{8,}/,
            },
            countryFetchSucceeded: false,
            countries: []
        };
    },
    validations: {
        user: {
            firstName: {required},
            lastName: {required},
            email: {required, email},
            confirmEmail: {required, sameAsEmail: sameAs('email')},
            password: {
                required,
                customPassword
            },
            confirmPassword: {required, sameAsPassword: sameAs('password')},
            company: {required},
            job: {required},
            business: {required},
            country: {required},
            terms: {
                checked(value) {
                    return value
                }
            }
        }
    },
    computed: {
        ...mapAsyncGetters(REGISTER_USER)
    },
    watch: {
        status: function (newValue) {
            if (this.isFinished) {
                if (newValue === STATUS.SUCCESS) {
                    this.$router.push("thank-you-for-registering");
                } else if (newValue === STATUS.FAILURE) {
                    this.$router.push("registration-and-login-error");
                }
            }
        },
    },
    async mounted() {
        await UserService.getCountries()
                .then(({data}) => {
                    this.countryFetchSucceeded = data.items.length > 0;
                    if (this.countryFetchSucceeded) {
                        this.countries = data.items;
                    }
                });
    },
    methods: {
        validFeedBack(regex) {
            return regex.test(this.user.password) ?
                    'password__feedback password__feedback--valid' :
                    'password__feedback password__feedback--invalid'
        },
        validIcon(regex) {
            return regex.test(this.user.password) ?
                    'lnr lnr-checkmark-circle' :
                    'lnr lnr-cross-circle';
        },
        async handleSubmit() {

            // stop here if form is invalid
            this.$v.$touch();
            this.submitted = true;
            if (this.$v.$invalid || this.validPasswordHistory === false) {
                this.formErrors = true;
            } else {
                this.user.token = await this.$recaptcha('registration');
                await this.$store.dispatch(REGISTER_USER, this.user)
                        .then(() => this.$store.dispatch(FINALIZE_ACTION, REGISTER_USER))
            }
        }
    }
};
</script>
